export default __webpack_public_path__ + "static/media/programmer-animate.42328239.svg";